var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "lg:hidden",
      class: { hidden: _vm.sidebarOpen },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "22",
            height: "26",
            viewBox: "0 0 22 26",
            fill: "none",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M0 5.14284C0 4.27364 0.702232 3.57141 1.57143 3.57141H20.4286C21.2978 3.57141 22 4.27364 22 5.14284C22 6.01204 21.2978 6.71427 20.4286 6.71427H1.57143C0.702232 6.71427 0 6.01204 0 5.14284ZM0 13C0 12.1308 0.702232 11.4286 1.57143 11.4286H20.4286C21.2978 11.4286 22 12.1308 22 13C22 13.8692 21.2978 14.5714 20.4286 14.5714H1.57143C0.702232 14.5714 0 13.8692 0 13ZM22 20.8571C22 21.7263 21.2978 22.4286 20.4286 22.4286H1.57143C0.702232 22.4286 0 21.7263 0 20.8571C0 19.9879 0.702232 19.2857 1.57143 19.2857H20.4286C21.2978 19.2857 22 19.9879 22 20.8571Z",
              fill: "black",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }